import React from 'react';
import { shape, string, number } from 'prop-types';
import { getImageUrl } from 'helpers/Utils';
import Paragraph from './Paragraph';
import Small from './Small';
import LazyLoadImg from './LazyLoadImg';
import './BlogPane.scss';

const BlogPane = ({
  image = {},
  title,
  description,
  link,
  imageWidth,
}) => (
  <div className="blog-pane" data-selector-type="blog-pane">
    <a href={link} rel="noopener noreferrer" target="_blank" data-selector-type="blog-pane-link">
      <div className="content-wrapper">
        <div className="image-wrapper" data-selector-type="blog-pane-img">
          <LazyLoadImg
            className="image"
            src={image && getImageUrl(image.url, { width: imageWidth })}
            alt={image && image.description}
            title={image && image.description}
          />
        </div>
        <div className="text-wrapper" data-selector-type="blog-pane-body">
          <Paragraph className="title">
            {title}
          </Paragraph>
          <div className="description">
            <Small secondary>
              <span className="description-inner" data-selector-type="blog-pane-description">
                {description}
              </span>
            </Small>
          </div>
        </div>
      </div>
      <hr className="divider" />
    </a>
  </div>
);

BlogPane.propTypes = {
  image: shape({
    url: string.isRequired,
    description: string,
  }).isRequired,
  imageWidth: number.isRequired,
  title: string.isRequired,
  description: string.isRequired,
  link: string.isRequired,
};

export default BlogPane;
